module.exports = __webpack_public_path__ + "static/media/banner6.0c02fe98.jpg";